import { render, staticRenderFns } from "./TruckIcon.vue?vue&type=template&id=65bfc664&scoped=true"
import script from "./TruckIcon.vue?vue&type=script&lang=js"
export * from "./TruckIcon.vue?vue&type=script&lang=js"
import style0 from "./TruckIcon.vue?vue&type=style&index=0&id=65bfc664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bfc664",
  null
  
)

export default component.exports